export const delay = (fn: Function, seconds: number, container?: any): Promise<void> => {
    return new Promise((resolve, reject) => {
        const timer = setTimeout(async () => {
            try {
                const result = await fn()
                resolve(result)
            } catch (error) {
                reject(error)
            }
        }, seconds * 1000)

        if (container && 'delayTimer' in container) {
            container.delayTimer = timer
        }
    })
}

export const sleep = (ms: number): Promise<void> =>
    new Promise((res) => {
        setTimeout(() => {
            res()
        }, ms)
    })
